<div class="ub ub-ver fw">
  <a-tabs :active-key="value" @change="changeTab">
    <a-tab-pane
      :key="item.type"
      :tab="item.name + '(' + item.total + ')'"
      v-for="(item, index) in flowStatusArr"
    >
    </a-tab-pane>
    <template #rightExtra>
      <slot name="rightButton">
        <a-button type="primary" v-perm="'/project/profile/create'" @click="onProjectDesign">
          <template #icon><arrow-right-outlined /></template>
          项目登记
        </a-button>
      </slot>
    </template>
  </a-tabs>
</div>
